var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero__container"},[(_vm.slice.primary.hero_image)?_c('prismic-image',{attrs:{"field":_vm.slice.primary.hero_image}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }